export default __webpack_public_path__ + "callWaiting.3a095bb0ff42d08db88709bdf2c54741.svg";